import * as React from "react";
import styled from "@mui/material/styles/styled";
import { PatientCaseGrouping } from "../../../context/diagnosticAgent";
import { TabSelection } from "../editPatient/DataInputPanelArea";
import { MobileView } from "../../../util/aKaunGeneralUtil";
import { RosebudColorMap } from "../rosebud/rosebudColorMap";
import { BackButton } from "./backButton";
import { MobileOnly } from "../util/mobileOnly";
//region [[ Styles ]]

const SectionMainTitleView = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",

  marginRight: "10px",

  marginBottom: theme.spacing(2),

  [theme.breakpoints.down(MobileView)]: {
    marginBottom: theme.spacing(0),
  },
}));

const TitleContainer = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
}));

export const SectionTitle = styled("div")(
  ({ theme, align }: { theme?: any; align?: "left" | "center" | "right" }) => ({
    paddingRight: "10px",
    fontSize: "36px",
    [theme.breakpoints.down(MobileView)]: {
      fontSize: "22px",
    },
    fontWeight: 500,
    textAlign: align ? align : "left",
  }),
);

export const SectionSubTitle = styled("div")(
  ({ theme, align }: { theme?: any; align?: "left" | "center" | "right" }) => ({
    paddingRight: "10px",
    fontSize: "14px",
    [theme.breakpoints.down(MobileView)]: {
      fontSize: "12px",
    },
    color: RosebudColorMap.green2,

    fontWeight: 400,
    textAlign: align ? align : "left",
  }),
);

const TitleBackButton = styled(BackButton)({
  fontSize: "18px",
  margin: 0,
  color: "white",
  lineHeight: "22px",
});

//endregion [[ Styles ]]

//region [[ Props ]]

export interface SectionMainTitleProps {
  className?: string;
  selection: TabSelection;
  title?: string;
  onBackClicked?: () => void;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

const KnownSectionTranslations = {
  [PatientCaseGrouping.BACKGROUND]: "Past Medical History",
  [PatientCaseGrouping.CLINICAL_FEATURES]: "Physical Examination",
  [PatientCaseGrouping.REVIEW_OF_SYSTEMS]: "Review Of Systems",
  [PatientCaseGrouping.WORKUP]: "Workup",
};

export const SectionMainTitle = (props: SectionMainTitleProps) => {
  return (
    <SectionMainTitleView className={props.className}>
      {props.onBackClicked && (
        <MobileOnly>
          <TitleBackButton onClick={props.onBackClicked} />
        </MobileOnly>
      )}
      <TitleContainer className={"title-container"}>
        <SectionTitle className={"section-title"}>
          {props.title ||
            KnownSectionTranslations[props.selection.section] ||
            props.selection.section}
        </SectionTitle>
      </TitleContainer>
    </SectionMainTitleView>
  );
};
